import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const HsCodeExampleSchema = z.object({
  declaration_id: z.string(),
  description: z.string(),
  hs_code: z.string(),
  distance: z.number(),
});
export type HsCodeExample = z.infer<typeof HsCodeExampleSchema>;

export const HsCodeCandidateSchema = z.object({
  hs_code: z.string(),
  neighbor_count: z.number(),
  avg_distance: z.number(),
  best_distance: z.number(),
  confidence: z.number(),
  confidence_v2: z.number(),
  examples: z.array(HsCodeExampleSchema),
});
export type HsCodeCandidate = z.infer<typeof HsCodeCandidateSchema>;

export const AIModuleDataSchema = z.object({
  GivenDistance: z.null(),
  GivenSection: z.null(),
  GoodsItemNumber: z.literal(1),
  declarationId: z.string(),
  PredictedDistances: z.array(z.tuple([z.number(), z.string(), z.number(), z.number()])),
});
export type AIModuleData = z.infer<typeof AIModuleDataSchema>;

export const ValidateHsCodeBodySchema = z.object({
  description: z.string().min(1),
  suggested_hscode: z.union([z.string(), z.number()]),
  useIndexEndpoint: z.boolean().optional(),
  topK: z.number().int().positive().optional(),
});

export const ValidateHsCodeBatchBodySchema = z.array(
  z.object({
    description: z.string().min(1),
    suggested_hscode: z.union([z.string(), z.number()]).optional(),
  }),
);

export const hsCodeValidationContract = c.router({
  validateHsCode: {
    method: 'POST',
    path: '/validate-hscode',
    body: ValidateHsCodeBodySchema,
    responses: {
      200: AIModuleDataSchema,
    },
  },
  validateHsCodeBatch: {
    method: 'POST',
    path: '/validate-hscode-batch',
    body: ValidateHsCodeBatchBodySchema,
    responses: {
      200: z.array(AIModuleDataSchema),
    },
  },
});
